<template>
    <b-form-group>
        <b-form-radio-group @input="onSelection">
            <span v-if="!!minLabel">{{ minLabel }}</span>
            <b-form-radio v-for="item in range" :value="item" :key="item">
                {{ item }}
            </b-form-radio>
            <span v-if="!!maxLabel">{{ maxLabel }}</span>
        </b-form-radio-group>
    </b-form-group>
</template>
<script>
export default {
    props: {
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 10,
        },
        step: {
            type: Number,
            default: 1,
        },
        minLabel: {
            type: String,
        },
        maxLabel: {
            type: String,
        },
    },
    data: () => ({
        range: [],
        result: '',
    }),
    computed: {
        //
    },
    methods: {
        onSelection(val) {
            this.result = val
            this.$emit('input', val)
        },
    },
    created() {
        for (let i = this.min; i <= this.max; i = i + this.step) {
            this.range.push(i)
        }
    },
}
</script>
